import * as React from "react"

const SvgHeading4 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M3.5 17.857a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-8q0-.424.288-.712a.97.97 0 0 1 .712-.288.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712v3h4v-3a.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712v8a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713v-3h-4v3a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.287m15 0a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713v-2h-4a.97.97 0 0 1-.713-.287.97.97 0 0 1-.287-.713v-5a.97.97 0 0 1 .287-.712.97.97 0 0 1 .713-.288.97.97 0 0 1 .713.288.97.97 0 0 1 .287.712v4h3v-4q0-.424.288-.712a.97.97 0 0 1 .712-.288q.424 0 .712.288a.97.97 0 0 1 .288.712v4h1q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287h-1v2a.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287" />
  </svg>
)
export default SvgHeading4
